import { FormField } from 'components/shared/form';
import Form from 'mobx-react-form';
import { BASIS_TYPES } from 'shared/constants/expenses';
import { divide } from 'shared/utils/numberOperations';
import { ExpenseForecast } from 'types/underwriting/income-approach/expenses';

export const expenseForecastFormFields: FormField[] = [
  {
    name: 'incomeApproach',
    fields: [
      {
        name: 'expenses',
        fields: [
          {
            name: 'expenseForecastEntryMode',
            type: 'text',
            value: 'detailed',
          },
          {
            name: 'expenseForecastInputMethod',
            type: 'text',
            value: 'amount',
          },
          {
            name: 'totalExpenseForecastAmount',
            type: 'number',
            value: 0,
          },
          {
            name: 'expenseForecastRatio',
            type: 'number',
            value: 0,
          },
          {
            name: 'expenseForecasts',
            type: 'array',
            value: [],
          },
        ],
      },
    ],
  },
];

export const expenseForecastFormHelpers = {
  updateExpenseForecast: (form: Form, key: string, field: string, value: any) => {
    const expenseForecastsField = form.$('incomeApproach.expenses.expenseForecasts');
    const expenseForecasts = expenseForecastsField.value;
    const index = expenseForecasts.findIndex((expense: ExpenseForecast) => expense.key === key);
    if (index > -1) {
      expenseForecasts[index][field] = value;
      expenseForecastsField.set(expenseForecasts);
    } else {
      expenseForecasts.push({
        key,
        basis: BASIS_TYPES.psf,
        concludedValue: 0,
        [field]: value,
      });
      expenseForecastsField.set(expenseForecasts);
    }
  },
  getConcludedValueByBasis: (
    concludedValue: number,
    basis: string,
    grossBuildingArea: number,
    residentialUnits: number,
    effectiveGrossIncome: number
  ) => {
    let total = concludedValue;
    switch (basis) {
      case BASIS_TYPES.psf:
        total = concludedValue * grossBuildingArea;
        return {
          total,
          psf: concludedValue,
          perUnit: divide(total, residentialUnits),
        };
      case BASIS_TYPES.perUnit:
        total = concludedValue * residentialUnits;
        return {
          total,
          psf: divide(total, grossBuildingArea),
          perUnit: concludedValue,
        };
      case BASIS_TYPES.percentOfEGI:
        total = (concludedValue / 100) * effectiveGrossIncome;
        return {
          total,
          psf: divide(total, grossBuildingArea),
          perUnit: divide(total, residentialUnits),
          percentOfEGI: concludedValue,
        };
      case BASIS_TYPES.total:
      default:
        return {
          total: concludedValue,
          psf: divide(concludedValue, grossBuildingArea),
          perUnit: divide(concludedValue, residentialUnits),
        };
    }
  },
};
